import { api } from "./useApi";

export const meetApi = () => ({
    getMeets: async () => {
        let response = await api.post("/meet/listar");
        return response.data;
      },
});
